import React from 'react';
import { Modal, Table, Badge, Card, Row, Col, Alert } from 'react-bootstrap';

const WinBackStatsModal = ({ show, onHide, stats, loading }) => {
    if (!stats || !stats.dashboard) return null;

    const { dashboard, detalhes } = stats;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>📊 Relatório de Campanha (Win-Back)</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                {loading ? (
                    <div className="text-center py-5">
                        <span className="spinner-border text-primary" role="status" />
                        <p className="mt-2 text-muted">Carregando estatísticas...</p>
                    </div>
                ) : (
                    <>
                        {/* KPIs */}
                        <Row className="g-3 mb-4">
                            <Col md={3}>
                                <Card className="border-0 shadow-sm text-center h-100">
                                    <Card.Body>
                                        <h6 className="text-muted mb-2">Total Cliques</h6>
                                        <h3 className="text-primary fw-bold mb-0">{dashboard.totalAcessos}</h3>
                                        <small className="text-muted">acessos aos links</small>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3}>
                                <Card className="border-0 shadow-sm text-center h-100">
                                    <Card.Body>
                                        <h6 className="text-muted mb-2">Clientes Alcançados</h6>
                                        <h3 className="text-dark fw-bold mb-0">{dashboard.totalClientesAcessaram}</h3>
                                        <small className="text-muted">únicos</small>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3}>
                                <Card className="border-0 shadow-sm text-center h-100">
                                    <Card.Body>
                                        <h6 className="text-muted mb-2">Conversões</h6>
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <h3 className="text-success fw-bold mb-0">{dashboard.totalConversoes}</h3>
                                            <Badge bg="success" className="d-flex align-items-center">
                                                {dashboard.taxaConversao}%
                                            </Badge>
                                        </div>
                                        <small className="text-muted">clientes compraram</small>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3}>
                                <Card className="border-0 shadow-sm text-center h-100 bg-success bg-opacity-10">
                                    <Card.Body>
                                        <h6 className="text-success mb-2">Receita Recuperada</h6>
                                        <h4 className="text-success fw-bold mb-0">
                                            R$ {dashboard.receitaRecuperada?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                        </h4>
                                        <small className="text-muted">em vendas pós-clique</small>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Tabela de Detalhes */}
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="p-0">
                                <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                    <Table hover className="mb-0 align-middle">
                                        <thead className="bg-light sticky-top">
                                            <tr>
                                                <th className="ps-3">Cliente</th>
                                                <th className="text-center">Acessos</th>
                                                <th className="text-center">Status</th>
                                                <th className="text-end pe-3">Valor Gasto</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detalhes.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4 text-muted">
                                                        Nenhum clique registrado ainda.
                                                    </td>
                                                </tr>
                                            ) : (
                                                detalhes.map((item, idx) => (
                                                    <tr key={idx} className={item.comprou ? 'table-success' : ''}>
                                                        <td className="ps-3">
                                                            <div className="fw-bold">{item.nome}</div>
                                                            <div className="small text-muted">
                                                                Último acesso: {new Date(item.ultimo_acesso).toLocaleDateString('pt-BR')} às {new Date(item.ultimo_acesso).toLocaleTimeString('pt-BR')}
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <Badge bg="secondary" pill>
                                                                {item.total_cliques}x
                                                            </Badge>
                                                        </td>
                                                        <td className="text-center">
                                                            {item.comprou ? (
                                                                <Badge bg="success">COMPROU 🎉</Badge>
                                                            ) : (
                                                                <Badge bg="light" text="dark" className="border">
                                                                    Visualizou
                                                                </Badge>
                                                            )}
                                                        </td>
                                                        <td className="text-end pe-3 fw-bold text-success">
                                                            {item.comprou ? (
                                                                `R$ ${item.valor_recuperado?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                                                            ) : '-'}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>

                        <div className="mt-3 text-muted small">
                            <i className="bi bi-info-circle me-1"></i>
                            A conversão é contabilizada quando o cliente realiza uma compra em data posterior ou igual ao seu primeiro clique no link rastreado.
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className="w-100 d-flex justify-content-between align-items-center">
                    <small className="text-muted">Dados atualizados em tempo real.</small>
                    <button className="btn btn-secondary" onClick={onHide}>Fechar</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default WinBackStatsModal;
